module.exports = __webpack_public_path__ + "static/media/fotografo.fd28673b.svg";